import { Injectable } from '@angular/core';
import { DataBagService } from '@/common/data-bag.service';
import {
	BagAgenciesResponse,
	BagCurrenciesResponse,
	BagOrganizationsResponse,
	BagPaymentOrganization,
	BagPaymentTermCurrency,
	BagPaymentTermProduct,
	BagProductsResponse,
} from '@/bag/bag-payment-term-list/bag-payment-term-list.model';

@Injectable({
	providedIn: 'root',
})
export class BagPaymentTermListApiService {
	constructor(private readonly bag: DataBagService) {}

	getCurrencies(queryParams: string): Promise<BagPaymentTermCurrency[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/currency/${queryParams}`, (result: BagCurrenciesResponse, error: Error) => {
				if (error) {
					reject([]);
				} else {
					resolve(result.results);
				}
			});
		});
	}

	getOrganizations(queryParams: string): Promise<BagPaymentOrganization[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/organization/${queryParams}`, (result: BagOrganizationsResponse, error: Error) => {
				if (error) {
					reject([]);
				} else {
					resolve(result.results);
				}
			});
		});
	}

	getAgencies(queryParams: string): Promise<BagPaymentOrganization[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/organization/${queryParams}`, (result: BagAgenciesResponse, error: Error) => {
				if (error) {
					reject([]);
				} else {
					resolve(result.results);
				}
			});
		});
	}

	getProducts(queryParams: string): Promise<BagPaymentTermProduct[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/product/${queryParams}`, (result: BagProductsResponse, error: Error) => {
				if (error) {
					reject([]);
				} else {
					resolve(result.results);
				}
			});
		});
	}
}
